module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', [_c('md-layout', {
    attrs: {
      "md-row": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [(_vm.editable) ? _c('md-checkbox', {
    on: {
      "change": _vm.changeEdit
    },
    model: {
      value: (_vm.layerPerms),
      callback: function($$v) {
        _vm.layerPerms = $$v
      },
      expression: "layerPerms"
    }
  }) : _c('md-checkbox', {
    attrs: {
      "disabled": ""
    },
    on: {
      "change": _vm.changeEdit
    },
    model: {
      value: (_vm.layerPerms),
      callback: function($$v) {
        _vm.layerPerms = $$v
      },
      expression: "layerPerms"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "md-body-1"
  }, [_vm._v(_vm._s(_vm.layer.title))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dc526ec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/layer-permission.vue
// module id = 1221
// module chunks = 21